import ApplicationModel, { attr } from '../ApplicationModel';
import { type ReleaseResourceEventAttributes } from './generated/ReleaseResourceEventAttributes';
import { model } from '../modelBuilder';

interface ReleaseResourceEvent extends ReleaseResourceEventAttributes {}

@model
class ReleaseResourceEvent extends ApplicationModel {
  // Start auto-generated
  static typename: 'ReleaseResourceEvent' = 'ReleaseResourceEvent';
  get typename(): 'ReleaseResourceEvent' {
    return 'ReleaseResourceEvent';
  }

  static internalTypename: 'ReleaseResourceEvent' = 'ReleaseResourceEvent';
  get internalTypename(): 'ReleaseResourceEvent' {
    return 'ReleaseResourceEvent';
  }

  static filterType = 'ReleaseResourceEventFilters!';
  static filters = { releaseId: 'ID!' };

  static fields = {
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    itemCountChange: attr({ readable: true }),
    kind: attr({ readable: true }),
    occurredOn: attr({ readable: true }),
    releaseId: attr({ readable: true }),
    resourceUnitChange: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    userId: attr({ readable: true }),
    release: attr.belongsTo({ readable: true, typename: 'Release' }),
    resourceable: attr.belongsTo({
      readable: true,
      typename: ['Epic', 'Feature', 'Requirement'],
    }),
    user: attr.belongsTo({ readable: true, typename: 'User' }),
  };
  // End auto-generated
}

export default ReleaseResourceEvent;
